<script setup>
import Print from '@/icons/printer.svg';

const open = true;
const currentUrl = window.location.href;
const mailto = `mailto:?body=${currentUrl}`;

const share = (type) => {
    const w = 550;
    const h = 450;
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top;
    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
    const height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
          ? document.documentElement.clientHeight
          : window.screen.height;
    const left = width / 2 - w / 2 + dualScreenLeft;
    const top = height / 2 - h / 2 + dualScreenTop;
    const urls = {
        facebook: 'https://www.facebook.com/sharer/sharer.php?u=',
        twitter: 'https://twitter.com/share?url=',
    };
    const url = urls[type] + encodeURI(currentUrl);
    const newWindow = window.open(url, '', `scrollbars=yes, width=${w}, height=${h}, top=${top}, left=${left}`);
    if (newWindow && newWindow.focus) newWindow.focus();
};

const print = () => {
    window.print();
};
</script>

<template>
    <div
        class="Share relative ml-6 mt-8 cursor-pointer print:hidden md:mt-16"
        :class="{ 'is-open': open }"
    >
        <div
            v-show="!open"
            class="Share__opener relative mb-16 h-10 w-10 origin-bottom transition"
        >
            <svg
                class="block fill-current text-dark-blue"
                viewBox="0 0 50 50"
            >
                <path
                    d="M27.88,15.33a1,1,0,0,0-1.37,1.37,6.33,6.33,0,0,1,1.17,2.09,9.9,9.9,0,0,0-8.7,7,10.05,10.05,0,0,0-.42,2.89v2.51a.88.88,0,1,0,1.75,0,8.33,8.33,0,0,1,.35-2.39,8.16,8.16,0,0,1,7-5.75A6.25,6.25,0,0,1,26.51,25a1,1,0,0,0,0,1.37,1,1,0,0,0,1.37,0l5.52-5.52Z"
                />
                <path d="M25,50A25,25,0,1,1,50,25,25,25,0,0,1,25,50ZM25,2A23,23,0,1,0,48,25,23,23,0,0,0,25,2Z" />
            </svg>
        </div>

        <div
            v-show="open"
            class="Share__container mb-16 inline-flex h-10 origin-bottom rounded-full border-2 border-dark-blue px-4 py-3 transition md:h-20 md:px-6 md:py-5"
        >
            <a
                class="Share__btn mb-0 mr-4 block cursor-pointer"
                v-on:click="share('facebook')"
            >
                <svg
                    class="h-4 w-auto fill-current text-dark-blue md:h-10"
                    viewBox="0 0 512 512"
                >
                    <path
                        d="M449.446,0c34.525,0 62.554,28.03 62.554,62.554l0,386.892c0,34.524 -28.03,62.554 -62.554,62.554l-106.468,0l0,-192.915l66.6,0l12.672,-82.621l-79.272,0l0,-53.617c0,-22.603 11.073,-44.636 46.58,-44.636l36.042,0l0,-70.34c0,0 -32.71,-5.582 -63.982,-5.582c-65.288,0 -107.96,39.569 -107.96,111.204l0,62.971l-72.573,0l0,82.621l72.573,0l0,192.915l-191.104,0c-34.524,0 -62.554,-28.03 -62.554,-62.554l0,-386.892c0,-34.524 28.029,-62.554 62.554,-62.554l386.892,0Z"
                    />
                </svg>
            </a>

            <a
                class="Share__btn mb-0 mr-4 block cursor-pointer"
                v-on:click="share('twitter')"
            >
                <svg
                    class="h-4 w-auto fill-current text-dark-blue md:h-10"
                    viewBox="0 0 512 512"
                >
                    <path
                        d="M449.446,0c34.525,0 62.554,28.03 62.554,62.554l0,386.892c0,34.524 -28.03,62.554 -62.554,62.554l-386.892,0c-34.524,0 -62.554,-28.03 -62.554,-62.554l0,-386.892c0,-34.524 28.029,-62.554 62.554,-62.554l386.892,0Zm-253.927,424.544c135.939,0 210.268,-112.643 210.268,-210.268c0,-3.218 0,-6.437 -0.153,-9.502c14.406,-10.421 26.973,-23.448 36.935,-38.314c-13.18,5.824 -27.433,9.809 -42.452,11.648c15.326,-9.196 26.973,-23.602 32.49,-40.92c-14.252,8.429 -30.038,14.56 -46.896,17.931c-13.487,-14.406 -32.644,-23.295 -53.946,-23.295c-40.767,0 -73.87,33.104 -73.87,73.87c0,5.824 0.613,11.494 1.992,16.858c-61.456,-3.065 -115.862,-32.49 -152.337,-77.241c-6.284,10.881 -9.962,23.601 -9.962,37.088c0,25.594 13.027,48.276 32.95,61.456c-12.107,-0.307 -23.448,-3.678 -33.41,-9.196l0,0.92c0,35.862 25.441,65.594 59.311,72.49c-6.13,1.686 -12.72,2.606 -19.464,2.606c-4.751,0 -9.348,-0.46 -13.946,-1.38c9.349,29.426 36.628,50.728 68.965,51.341c-25.287,19.771 -57.164,31.571 -91.8,31.571c-5.977,0 -11.801,-0.306 -17.625,-1.073c32.337,21.15 71.264,33.41 112.95,33.41Z"
                    />
                </svg>
            </a>

            <a
                class="Share__btn mb-0 mr-4 block cursor-pointer"
                :href="mailto"
                target="_blank"
            >
                <svg
                    class="h-4 w-auto fill-current text-dark-blue md:h-10"
                    viewBox="0 0 34 26"
                >
                    <path
                        d="M3.2,0C1.5,0,0.2,1.2,0,2.8C0,2.9,0,3,0,3.1l17,10.8L34,3.1c0-0.1,0-0.2,0-0.3 C33.8,1.2,32.5,0,30.8,0H3.2z M17,16.7L0,5.9v16.9C0,24.6,1.4,26,3.2,26h27.6c1.8,0,3.2-1.4,3.2-3.1V5.9L17,16.7z"
                    />
                </svg>
            </a>

            <a
                class="Share__btn mb-0 mr-4 block cursor-pointer"
                href="#print"
                v-on:click.prevent="print"
            >
                <svg
                    class="h-4 w-auto fill-current text-dark-blue md:h-10"
                    viewBox="0 0 33 33"
                >
                    <path
                        d="M26.423 8.143c1.1 0 2.163-.01 3.225.003 1.538.016 2.855 1.114 3.238 2.704.074.309.105.638.106.958.008 2.972.011 5.945.003 8.917-.006 2.166-1.48 3.743-3.485 3.75-1.024.004-2.048.001-3.126.001v6.694c0 1.19-.598 1.83-1.706 1.83H8.319c-1.105 0-1.698-.643-1.699-1.837v-6.695c-.132-.008-.243-.019-.354-.02-1.083-.013-2.168.03-3.247-.048C1.434 24.286.1 22.768.024 21.05c-.04-.916-.018-1.836-.017-2.753 0-2.242-.024-4.485.02-6.726.035-1.844 1.479-3.375 3.192-3.44a58.523 58.523 0 0 1 3.074-.01c.277.004.333-.095.331-.372-.01-1.96-.005-3.922-.005-5.882C6.62.637 7.212 0 8.352 0h16.33c1.115 0 1.741.676 1.741 1.877v6.266zm-9.895 9.838c-2.174 0-4.348.005-6.523-.007-.27-.001-.336.083-.335.367.008 3.67.008 7.338 0 11.008-.001.293.078.362.34.361 4.33-.008 8.659-.009 12.988 0 .27.002.336-.082.336-.366-.009-3.67-.009-7.339 0-11.008 0-.294-.08-.363-.34-.361-2.155.01-4.31.006-6.466.006zm6.8-9.85v-.31c0-1.386-.006-2.773.006-4.159.002-.263-.072-.33-.31-.33-4.35.007-8.698.008-13.047 0-.243 0-.309.076-.307.334.01 1.386.005 2.773.005 4.16v.307l13.653-.001z"
                    />
                </svg>
            </a>
        </div>
    </div>
</template>
